export {default} from "./Spotlight";
